import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import pageNotFound from "../../assets/images/page-not-found.jpg";

const NotFoundPage = () => {
  return (
    <div className="not-found-page">
      <div className="content-container">
        <h1 className="title">
          <FormattedMessage id="error.404.title"/>
        </h1>

        <p className="description">
          <FormattedMessage
            id="dataNotFoundError"
          />
        </p>

        <div className="image-container">
          <img
            src={pageNotFound}
            alt="Page Not Found"
            className="not-found-image"
          />
        </div>

        <Link to="/" className="go-home-link">
          <FormattedMessage id="error.404.link"/>
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/app/NotFoundPage.js